// tslint:disable:max-classes-per-file

import { Action } from '@ngrx/store';

import { Shift } from '../../models/shift';

export const ADD_SHIFT = '[Shift] add shift';
export const ADD_SHIFT_SUCCESS = '[Shift] add shift success';
export const ADD_SHIFT_FAIL = '[Shift] add shift fail';

export class AddShift implements Action {
  public readonly type = ADD_SHIFT;

  constructor(public payload: { shiftToAdd: Shift; shifts: Array<Shift> }) {}
}

export class AddShiftSuccess implements Action {
  public readonly type = ADD_SHIFT_SUCCESS;

  constructor(public payload: Array<Shift>) {}
}

export class AddShiftFail implements Action {
  public readonly type = ADD_SHIFT_FAIL;

  constructor(public payload: any = null) {}
}

export type ShiftSettingsAddActions = AddShift | AddShiftSuccess | AddShiftFail;
